'use client';



import { useCallback, useState } from 'react';

import { loginWithFacebook } from '@/platform/share/facebookSdk';



type Props = {

  disabled?: boolean;

  /** Called with a Facebook access token after login succeeds. */

  onAccessToken: (accessToken: string) => Promise<void>;

  /** Firebase popup fallback when the SDK is unavailable. */

  onFallbackClick?: () => void | Promise<void>;

};



function FacebookIcon() {

  return (

    <svg viewBox="0 0 24 24" aria-hidden>

      <path

        fill="currentColor"

        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"

      />

    </svg>

  );

}



export function FacebookSignInButton({

  disabled = false,

  onAccessToken,

  onFallbackClick,

}: Props) {

  const [busy, setBusy] = useState(false);

  const appId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID ?? '';



  const handleClick = useCallback(async () => {

    if (disabled || busy) return;

    setBusy(true);

    try {

      if (!appId) {

        await onFallbackClick?.();

        return;

      }

      try {

        const response = await loginWithFacebook(appId);

        const token = response.authResponse?.accessToken;

        if (token) {

          await onAccessToken(token);

        }

      } catch {

        await onFallbackClick?.();

      }

    } finally {

      setBusy(false);

    }

  }, [appId, busy, disabled, onAccessToken, onFallbackClick]);



  return (

    <button

      type="button"

      className="btn btn-facebook"

      disabled={disabled || busy}

      data-testid="oauth-facebook"

      aria-busy={busy}

      onClick={() => void handleClick()}

    >

      <FacebookIcon />

      Sign in with Facebook

    </button>

  );

}

